// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_d2-b";
export var colorBlue = "_d2-8";
export var colorDot = "_d2-0";
export var colorDotLarge = "_d2-2";
export var colorDotSmall = "_d2-1";
export var colorGreen = "_d2-7";
export var colorGrey = "_d2-3";
export var colorOrange = "_d2-5";
export var colorPink = "_d2-a";
export var colorPurple = "_d2-9";
export var colorRed = "_d2-4";
export var colorYellow = "_d2-6";